export const getVendorSplitKey = ({
  primaryBusinessId,
  deploymentId,
  saleLotId,
  consignmentId,
  livestockSaleId,
}) =>
  [
    primaryBusinessId,
    deploymentId,
    saleLotId,
    consignmentId,
    livestockSaleId,
  ].join("|");
